import React, { Fragment } from "react";

import { V2 } from "../../Api";
import { formatDateLocalNumeric, formatName, } from "../../Utilities";

import Style from "../labelsheet.module.css";

interface ISurgeryPatientLabelSheetViewState {
    error?: string;
    isLoading: boolean;

    labels: any[];
    barcodeImages: { [id: string]: string };
}

class SurgeryPatientLabelSheetView extends React.Component<{}, ISurgeryPatientLabelSheetViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            isLoading: false,

            labels: [],
            barcodeImages: {}
        };

        this.handleMessage = this.handleMessage.bind(this);
    }

    public componentDidMount() {
        // Request report data from main window
        window.addEventListener("message", this.handleMessage, false);
        window.opener?.postMessage({ action: "surgery_label_sheet_request" }, "*");
    }

    public componentWillUnmount() {
        window.removeEventListener("message", this.handleMessage);

        for (const item of Object.keys(this.state.barcodeImages)) {
            URL.revokeObjectURL(this.state.barcodeImages[item]);
        }
    }

    public render() {
        if (this.state.error) {
            return <div className="error-box">{this.state.error}</div>;
        }

        if (this.state.isLoading) {
            return <div className="spinner spinner-full spinner-full-root lds-dual-ring-big" />;
        }

        return (
            <div className="page-flow-root page-size-letter-portait">
                <div className={`print-page-pseudo ${Style.labelSheet}`}>
                    <div className={Style.sheet}>
                        {this.state.labels.map((a: any[], i) => <Fragment key={i}>
                            {a.map((b, i2) => this.renderLabel({
                                index: i2,
                                row: i + 1,
                                barcodeData: b.barcodeData,
                                chartNumber: b.chartNumber,
                                birthDate: b.birthDate,
                                name: b.name,
                                documentName: b.documentName,
                                mode: b.mode,
                                address: b.address
                            }))}
                        </Fragment>)}
                    </div>
                </div>
            </div>
        );
    }

    private renderLabel(data: any) {
        if (data.mode === "address") {
            return <div key={data.index} className={Style.sticker} style={{ gridRow: data.row, marginLeft: "3mm" }}>
                <div className={Style.info}>
                    {data.chartNumber}&nbsp;&nbsp;&nbsp;&nbsp;{formatDateLocalNumeric(data.birthDate)}<br />
                    {formatName(data.name)}<br />
                    <br />
                    {data.address?.street}<br />
                    {data.address?.city}, {data.address?.state} {data.address?.zip}
                </div>
            </div>;
        }
        else {
            return <div key={data.index} className={Style.sticker} style={{ gridRow: data.row }}>
                <img src={this.state.barcodeImages[data.barcodeData]} alt="Barcode label" />
                <div className={Style.info}>
                    {data.chartNumber}&nbsp;&nbsp;&nbsp;&nbsp;{formatDateLocalNumeric(data.birthDate)}<br />
                    {formatName(data.name)}<br />
                    <br />
                    {data.documentName}
                </div>
            </div>;
        }
    }

    private processParameters() {
        window.setTimeout(() => {
            window.print();
            window.close();
        }, 1000);
    }

    private handleMessage(e: MessageEvent) {
        if (e.data?.action === "surgery_label_sheet_parameters") {
            // Receiving report parameters
            this.loadBarcodeImages((e.data.labels as any[]).flat(1).filter(a => !!a.barcodeData).map(a => a.barcodeData as string).filter((v, i, arr) => arr.indexOf(v) === i))
                .then(images => {

                    this.setState({
                        labels: e.data.labels,
                        barcodeImages: images
                    }, () => this.processParameters());
                })
                .catch(e => {
                    this.setState({
                        error: e.message || "Could not load barcodes"
                    })
                });
        }
        else if (e.data?.action === "surgery_label_sheet_error") {
            this.setState({
                error: e.data.error
            });
        }
    }

    private async loadBarcodeImages(values: any[]) {
        const images: { [id: string]: string } = {};

        for (const value of values) {
            const image = await V2.get<Blob>(`tools/qr-generate?data=${encodeURIComponent(value)}`);
            images[value] = URL.createObjectURL(image);
        }

        return images;
    }
}

export default SurgeryPatientLabelSheetView;
